'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of current supps mobile
 */ const CurrentSuppsMobile = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 103 103",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "51.5",
                cy: "51.5",
                r: "51.5",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.625",
                y: "68.4043",
                width: "17.4284",
                height: "5.17675",
                rx: "1.62102",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.1361 18.7031H62.4158C64.0344 18.7121 65.5838 19.3601 66.7268 20.5061C67.8697 21.652 68.5135 23.2031 68.5179 24.8215V78.1958C68.5135 79.8171 67.8673 81.3707 66.7207 82.5172C65.5741 83.6636 64.0203 84.3097 62.3988 84.3141H40.1191C38.4976 84.3097 36.9438 83.6636 35.7972 82.5172C34.6506 81.3707 34.0045 79.8171 34 78.1958V66.4562V58.9005V57.0449V24.8215C34.0045 23.1972 34.653 21.6411 35.8032 20.4941C36.9535 19.3472 38.5117 18.7031 40.1361 18.7031Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M57.8335 68.4863H44.7198C43.3234 68.4863 42.1914 69.6182 42.1914 71.0144C42.1914 72.4106 43.3234 73.5425 44.7198 73.5425H57.8335C59.2299 73.5425 60.3619 72.4106 60.3619 71.0144C60.3619 69.6182 59.2299 68.4863 57.8335 68.4863Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "48.375",
                y: "73.5391",
                width: "5.98958",
                height: "5.85648",
                rx: "2.92824",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "36.6602",
                y: "21.6309",
                width: "29.4155",
                height: "48.4491",
                rx: "1.98796",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "50.9957",
                cy: "33.6988",
                r: "6.99566",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("mask", {
                id: "mask0_3459_2871",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "44",
                y: "26",
                width: "14",
                height: "15",
                children: /*#__PURE__*/ jsxRuntime.jsx("circle", {
                    cx: "50.9958",
                    cy: "33.6988",
                    r: "6.99566",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                mask: "url(#mask0_3459_2871)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M50.9865 34.7201C52.6196 34.7201 53.9526 33.3928 53.9526 31.7498C53.9526 30.1068 52.6196 28.7871 50.9865 28.7871C49.3534 28.7871 48.0197 30.1144 48.0197 31.7498C48.0197 33.3852 49.3526 34.7201 50.9865 34.7201Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M45.8541 37.4938C45.7276 37.8589 45.618 38.2246 45.5314 38.5974C46.8773 40.0907 48.8218 41.0364 50.9718 41.0364C53.1217 41.0364 55.0937 40.3219 56.4404 38.8286C56.3538 38.4559 56.2152 37.8596 56.0887 37.4938C55.6395 36.2225 54.6876 35.245 53.5141 34.7207C52.7898 35.2288 51.9084 35.5234 50.971 35.5234C50.0336 35.5234 49.1522 35.2296 48.4279 34.7284C47.2467 35.245 46.3017 36.2302 45.8533 37.4938H45.8541Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M55.0678 51.4881V49.9462C55.6809 49.9462 56.1779 49.4492 56.1779 48.8361V48.1512C56.1779 47.5305 55.6747 47.0273 55.054 47.0273H47.1283C46.5076 47.0273 46.0044 47.5305 46.0044 48.1512V48.8361C46.0044 49.4492 46.5014 49.9462 47.1145 49.9462V51.5109C46.5054 51.7334 45.98 52.1335 45.6091 52.6577C45.2381 53.1819 45.0392 53.8051 45.0391 54.4435V64.4417C45.0391 65.0624 45.5422 65.5655 46.163 65.5655H56.0864C56.7072 65.5655 57.2103 65.0624 57.2103 64.4417V54.4449C57.2103 53.7944 57.004 53.1601 56.62 52.6302C56.236 52.1003 55.6935 51.7011 55.0678 51.4881Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "45.8242",
                y: "46.9473",
                width: "10.5222",
                height: "2.99299",
                rx: "0.953839",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.CurrentSuppsMobile = CurrentSuppsMobile;
//# sourceMappingURL=CurrentSuppsMobile.cjs.map
